import {
  Box,
  Flex,
  FlexAnchor,
  Icon,
  mdBumps,
  ModalHeader,
  smBumps,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { hasName, Profile } from '../../../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { ProfileButton } from './ProfileButton'

export interface AddProfileModalProps {
  profiles: Profile[]
  onAdd: (profile?: Profile) => void
  maxAdditionalProfiles: number
  currentAdditionalProfiles: number
}

const tKey = TKey('components.add-profile-modal')

const AddProfileModal: FunctionComponent<AddProfileModalProps> = ({
  profiles,
  onAdd,
  maxAdditionalProfiles,
  currentAdditionalProfiles,
}) => {
  const { t } = useWriskTranslation()

  return (
    <Box>
      <ModalHeader
        className='modal-header'
        header={t(tKey('header'))}
        subheader={t(tKey('subheader'), {
          count: maxAdditionalProfiles - currentAdditionalProfiles,
          maxAdditionalProfiles,
        })}
      />
      <Flex width={1} py={2} flexWrap='wrap' variant='raised' flexDirection='column'>
        {profiles.filter(hasName).map((profile) => (
          <ProfileButton
            key={profile.profileCode}
            profile={profile}
            onClick={onAdd}
            referred={false}
            complete={false}
            tKey={tKey}
          />
        ))}
        <FlexAnchor
          width={1}
          justifyContent='flex-start'
          variant='inset'
          px={mdBumps}
          py={3}
          onClick={() => onAdd()}
          data-testid='add-new-driver'
        >
          <Icon icon='plus' mr={smBumps} />
          <Typo>{t(tKey('actions.add'))}</Typo>
        </FlexAnchor>
      </Flex>
    </Box>
  )
}

export default AddProfileModal
